import isMobile from './is-mobile';

const TOUCH_TOLERANCE = 10;

function handleTouchStart(handler) {
  return function(startEvent) {
    var { screenX: x, screenY: y } = startEvent.touches[0];
    var touchStartPosition = { x, y };
    var lastTouchPosition = { x, y };
    function handleTouchEnd(endEvent) {
      document.removeEventListener('touchend', handleTouchEnd);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchcancel', handleTouchCancel);
      var { x: startX, y: startY } = touchStartPosition;
      var { x: endX, y: endY } = lastTouchPosition;
      var deltaX = Math.abs(startX - endX);
      var deltaY = Math.abs(startY - endY);
      var delta = Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
      if (delta < TOUCH_TOLERANCE) {
        handler(endEvent);
      }
    }
    function handleTouchCancel() {
      document.removeEventListener('touchend', handleTouchEnd);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchcancel', handleTouchCancel);
    }
    function handleTouchMove(moveEvent) {
      var { screenX, screenY } = moveEvent.touches[0];
      lastTouchPosition = { x: screenX, y: screenY };
    }
    document.addEventListener('touchend', handleTouchEnd);
    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchcancel', handleTouchCancel);
  };
}

// Touch/Click for React components
// Usage:
//   import { onTap } from '.../tap-events';
//   <Component { ...onTap(handler) } />
export function onTap(handler) {
  var props = {};

  if (isMobile) {
    props.onTouchStart = handleTouchStart(handler);
  } else {
    props.onClick = handler;
  }

  return props;
}

// Generic touch/click event handler
// Usage:
//   import { addTapEventListener } from '.../tap-events';
//   addTapEventListener(document, handler);
export function addTapEventListener(target, handler) {
  if (isMobile) {
    var touchHandler = handleTouchStart(handler);
    target.addEventListener('touchstart', touchHandler);
    return () => {
      target.removeEventListener('touchstart', touchHandler);
    };
  } else {
    target.addEventListener('click', handler);
    return () => target.removeEventListener('click', handler);
  }
}
